import React, { useState, useEffect } from 'react';
import css from './style.scss';

const RenameListModal = ({
  isOpen,
  onClose,
  onSave,
  title = 'Rename',
  description = '',
  initialValue = '',
  placeholder = 'Enter name',
  saveButtonText = 'Save',
  cancelButtonText = 'Cancel',
  checkOptions = null,
}) => {
  const [value, setValue] = useState(initialValue);
  const [options, setOptions] = useState(checkOptions);

  useEffect(() => {
    if (isOpen) {
      setValue(initialValue);
      setOptions(checkOptions);
    }
  }, [isOpen, initialValue, checkOptions]);

  const handleSave = () => {
    if (value.trim()) {
      onSave(value.trim(), { checkOptions: options ? options.filter(opt => opt.checked) : [] });
      onClose();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    }
  };

  const handleCheckboxChange = (optionId) => {
    if (!options) return;
    setOptions(prevOptions =>
      prevOptions.map(opt =>
        opt.id === optionId ? { ...opt, checked: !opt.checked } : opt
      )
    );
  };

  const isSaveDisabled = !value.trim();

  if (!isOpen) return null;

  return (
    <div className={css.modalOverlay} onClick={onClose}>
      <div className={css.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div>
          <h2 className={css.modalTitle}>{title}</h2>
          {description && (
            <div className={css.modalText}>{description}</div>
          )}
        </div>

        <input
          type="text"
          autoComplete="off"
          className={css.modalInput}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          autoFocus
        />

        {options && options.map(option => (
          <div key={option.id} className={css.checkboxContainer}>
            <input
              type="checkbox"
              id={option.id}
              checked={option.checked || false}
              onChange={() => handleCheckboxChange(option.id)}
            />
            <label htmlFor={option.id}>{option.label}</label>
          </div>
        ))}

        <div className={css.modalActions}>
          <button
            className={css.cancelButton}
            onClick={onClose}
          >
            {cancelButtonText}
          </button>
          <button
            className={css.saveButton}
            onClick={handleSave}
            disabled={isSaveDisabled}
          >
            {saveButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenameListModal;